export default __webpack_public_path__ + "static/media/settings.030633a3.svg";